module.exports = __webpack_public_path__ + "admin_static/img/newlogo.27e01a6c.png";